import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["bcc", "body", "cc", "children", "email", "subject"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import r, { useState as d } from "react";
function E(t) {
  var _t = _slicedToArray(t, 2),
    e = _t[1];
  return typeof e == "string" && e.length > 0;
}
function g(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    t = _ref2[0],
    e = _ref2[1];
  return Array.isArray(e) ? [t, e.join(",")] : [t, e];
}
function h(t) {
  return Object.entries(t).map(g).filter(E).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      e = _ref4[0],
      n = _ref4[1];
    return "".concat(e, "=").concat(encodeURIComponent(n));
  }).join("&");
}
function y(t) {
  var _t$split = t.split("@"),
    _t$split2 = _slicedToArray(_t$split, 2),
    e = _t$split2[0],
    n = _t$split2[1];
  return /* @__PURE__ */r.createElement(r.Fragment, null, /* @__PURE__ */r.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n          a>span.roe::after {\n            content: \"@\";\n          }\n        "
    }
  }), e, /* @__PURE__ */r.createElement("span", {
    className: "roe"
  }), n);
}
function T(_ref5) {
  var _ref5$bcc = _ref5.bcc,
    t = _ref5$bcc === void 0 ? [] : _ref5$bcc,
    _ref5$body = _ref5.body,
    e = _ref5$body === void 0 ? "" : _ref5$body,
    _ref5$cc = _ref5.cc,
    n = _ref5$cc === void 0 ? [] : _ref5$cc,
    a = _ref5.children,
    o = _ref5.email,
    _ref5$subject = _ref5.subject,
    m = _ref5$subject === void 0 ? "" : _ref5$subject,
    u = _objectWithoutProperties(_ref5, _excluded);
  var _d = d(!1),
    _d2 = _slicedToArray(_d, 2),
    s = _d2[0],
    l = _d2[1],
    c = new URL("mailto:".concat(o));
  c.search = h({
    bcc: t,
    body: e,
    cc: n,
    subject: m
  });
  function i() {
    l(!0);
  }
  var f = a || o,
    p = a || y(o);
  return /* @__PURE__ */r.createElement("a", _objectSpread({
    href: s ? c.href : "#",
    onFocus: i,
    onMouseOver: i
  }, u), s ? f : p);
}
export { T as Email };